import { UserNotificationsSystemItem } from '@infotech-soe/merps/types/Notifications';
import { isBefore } from 'date-fns';

import MerpsApiProvider from '../../../infrastructure/providers/pb-adapter/MerpsApiProvider';
import {
  SingleSystemNotification,
  SystemNotificationsViewModel,
} from '../../../models/notifications/Notifications';
import systemNotifications from '../../slices/systemNotifications';
import { apiCall, createAppListener, postDispatch } from '../listenerHelpers';

const systemNotificationsListener = createAppListener();

const apiProvider = new MerpsApiProvider();

const createSystemNotification = ({
  id,
  ts,
  kind,
  payload: { startTs, finishTs },
}: UserNotificationsSystemItem): SingleSystemNotification => ({
  id,
  ts: new Date(ts),
  kind,
  startTs: new Date(startTs),
  finishTs: new Date(finishTs),
  toShow: !isBefore(new Date(), new Date(ts)),
});

systemNotificationsListener.startListening(
  postDispatch(systemNotifications.received, (payload, _state, dispatch) => {
    dispatch(systemNotifications.append(createSystemNotification(payload)));
  })
);

systemNotificationsListener.startListening(
  apiCall(
    {
      request: systemNotifications.get,
      success: systemNotifications.getSuccess,
      failure: systemNotifications.getFailure,
    },
    async () => {
      const serverNotifications =
        await apiProvider.notifications.getUserNotifications();

      const notifications: SystemNotificationsViewModel = {};
      for (const sNotification of serverNotifications.system) {
        notifications[sNotification.id] =
          createSystemNotification(sNotification);
      }
      return notifications;
    }
  )
);

export default systemNotificationsListener.middleware;
